import { render, staticRenderFns } from "./widget_recent_delivery_errors.vue?vue&type=template&id=e0535758&"
import script from "./widget_recent_delivery_errors.vue?vue&type=script&lang=js&"
export * from "./widget_recent_delivery_errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports